// extracted by mini-css-extract-plugin
export default {"loading":"setFeedbackPost_loading__3wDCz","pcWrap":"setFeedbackPost_pcWrap__iUhyX"};